import { c as e } from "./createTheme-ef7fa3a1.js";
const t = e(), m = t;
export {
  m as d
};
//# sourceMappingURL=defaultTheme-9f1e13f4.js.map
